export type ScrollFrameHandler = (scroll: number, delta: number) => void;

const handlers = new Set<ScrollFrameHandler>();
let lastY = 0;

export function bindScrollFrameHandler(handler: ScrollFrameHandler) {
  handlers.add(handler);
}

export function unbindScrollFrameHandler(handler: ScrollFrameHandler) {
  handlers.delete(handler);
}

export function initScrollFramePosition(y: number) {
  lastY = y;
}

export function flushScrollFrame(scrollY?: number) {
  const y = scrollY ?? window.scrollY;
  const delta = y - lastY;
  if (Math.abs(delta) < 1e-4) {
    return;
  }
  lastY = y;
  handlers.forEach((h) => {
    h(y, delta);
  });
}
